import {Directive} from "@angular/core";

@Directive({
	selector: '[cpTabStripItem]'
})
export class TabStripItemTemplateDirective {}

